module.exports = __webpack_public_path__ + "static/1-b3e958db82bf4569d2f9c1381ce6f776.png";